import _ from "lodash"
import Channel from "data/websocket/channel"
import folderService, {Folder} from "data/folder"
import propertyService, {Property} from "data/property"
import versionService from "data/version"
import authService from "data/auth"
import notificationService from "data/notification"
import socketService, * as eventType from "data/socket"
import snapshotService from "data/snapshots"
import { local, setlocal } from "data/lib/local-json"

// UserChannel manages channel connections and events specific to properties
export default class UserChannel extends Channel {

  /* Local State */
  userConnected = false
  userId = undefined
  user_channel_debounce = undefined
  isConnecting = false
  sampleCreation = false

  // Join the user channel corresponding to current user id
  connectUser(userId) {
    if(this.isConnecting) return
    if(!this.userConnected) {
      this.isConnecting = true
      setTimeout(() => this.isConnecting = false, 100)
      this.userId = userId.toString();
      this.join('user', this.userId);
      this.userConnected = true;
    }

    this.onEvent(event => {
      let current: Folder | Property | null = null
      switch(event.eventType) {
        case eventType.LOGOUT_DUP_CLIENTS:
          const { msg: msgToken } = event;
          const rawToken = local("auth.token")
          const storedToken = rawToken ? JSON.parse(rawToken) : ""
          if (msgToken !== storedToken) {
            setlocal("rdcf_loggedOutDueToInactivity", true);
            authService.logout()
          }
          break;

        case eventType.APPVERSION:
          // emit version change notification after 30 minutes to allow deployment to finish
          setTimeout(() => versionService.newVersion(event.msg), 1800000);
          break;

        case eventType.DATA_EXPORT_READY:
          // Bi data export ready
          socketService.newEvent({ eventType: eventType.DATA_EXPORT_READY, event });
          break;

        case eventType.FOLDER_COPY_FINISHED:
          socketService.newEvent({ eventType: eventType.FOLDER_COPY_FINISHED, event })
          // pull the latest folders/properties for the current folder
          let currentFolderId = _.last(local('folderPath'))
          folderService.fetchAllFolders()
          if(currentFolderId) propertyService.fetchByFolderId(currentFolderId, false)
          // notificationService.notify({ type: "info", message: event.msg, dismiss: 5000 })
          break;

        case eventType.FOLDER_COPY_ERROR:
          socketService.newEvent({ eventType: eventType.FOLDER_COPY_ERROR, event })
          notificationService.notify({ type: "danger", message: event.msg, dismiss: 5000 })
          break;

        case eventType.FOLDER_COPY_WARNING:
          socketService.newEvent({ eventType: eventType.FOLDER_COPY_ERROR, event })
          notificationService.notify({ type: "warn", message: event.msg, dismiss: 5000 })
          break;

        case eventType.PROPERTY_COPY_FINISHED_EVENT:
          // get the new property
          propertyService.fetchProperty(event.msg.propertyId)
            .then(property => {
              notificationService.notify({ type: "info", message: "Property copy has completed", dismiss: 5000 })
              socketService.newEvent({ eventType: eventType.PROPERTY_COPY_FINISHED_EVENT, event: {property} })
            })
          break;

        case eventType.PROPERTY_COPY_ERROR_EVENT:
          socketService.newEvent({ eventType: eventType.PROPERTY_COPY_ERROR_EVENT, event })
          notificationService.notify({ type: "danger", message: event.msg, dismiss: 5000 })
          break;

        case eventType.PROPERTY_MOVE_FINISHED_EVENT:
          propertyService.fetchProperty(event.msg.propertyId)
            .then((property) => {
              socketService.newEvent({ eventType: eventType.PROPERTY_MOVE_FINISHED_EVENT, event })
              notificationService.notify({ type: "info", message: "Property move has completed", dismiss: 5000 })
            })
          break;

        case eventType.PROPERTY_MOVE_ERROR_EVENT:
          socketService.newEvent({ eventType: eventType.PROPERTY_MOVE_ERROR_EVENT, event })
          notificationService.notify({ type: "danger", message: event.msg, dismiss: 5000 })
          break;

        case eventType.SNAPSHOT_RESTORE_UPDATE:

          break;

        case eventType.PROPERTY_RESTORE_COMPLETE:
        //notificationService.notify({ type: 'success', message: `Snapshot of property ${event.msg['propertycode']} restored (${event.msg['progress']})`, dismiss: 5000 })
        break;

        case eventType.SNAPSHOT_RESTORE_COMPLETE:
          if(!this.sampleCreation) {
            if (event.msg['snapshotresult']['complete_msg'] != ''){
              notificationService.enqueue({
                correlationid: event.msg['snapshotid'],
                message: event.msg['snapshotresult']['complete_msg'],
                complete: true
              })
            }
            snapshotService.completeRestore(event.msg['snapshotresult'], event.msg['folderid'])
          }
          break;

        case eventType.SNAPSHOT_CREATE_UPDATE:
          console.log(`;;; Snapshot for properties ${event.msg['propertyids']} creation progress: ${event.msg['progress']*100|0}`)
          break;

        case eventType.SNAPSHOT_CREATE_COMPLETE:
          if(!this.sampleCreation) {
            if (event.msg.contenttype == "property"){
              notificationService.enqueue({
              correlationid: _.get(event, "msg.snapshotid") || _.get(event, "msg.snapshotresult.snapshotid"),
              message: `Snapshot of property ${event.msg.snapshotresult.results[0].propertycode} created`,
              complete: true
            })
            }
            else {
              notificationService.enqueue({
              correlationid: event.msg['snapshotid'],
              message: `Snapshot of folder ${event.msg.snapshotresult.foldercode} created`,
              complete: true
            })
            }
            snapshotService.completeSnapshot(event.msg.snapshotresult, event.msg.contenttype, event.msg.autodownload)
          }
          break;

        case eventType.IMPORT_PROGRESS:
        //   console.log(';;; Import progress job:', event.msg)
          break;

        case eventType.IMPORT_ERROR:
          console.log('Import Error:', event.msg.error)
          propertyService.fetchByFolderId(event.msg['folderid'], true)
          break;

        case eventType.IMPORT_COMPLETE:
          notificationService.enqueue({
            correlationid: event.msg['importjobid'],
            message: `AE Import: ${event.msg['filename']} complete `,
            complete: true
          })
          propertyService.fetchByFolderId(event.msg['folderid'], true)
          break;

        case eventType.FOLDER_COPY_UPDATE:
          // console.log('Folder copy progress', event.msg)
          break;

        case eventType.PROPERTY_COPY_UPDATE_EVENT:
          // console.log(`Property copy progress`, event.msg)
          break;


        case eventType.CREATE_SAMPLE_PROPERTIES:
          this.sampleCreation = true
          notificationService.notify({type: "info", message: event?.msg?.text, dismiss: 3000})
          break;

        case eventType.SAMPLE_PROPERTIES_FINISHED:
          this.sampleCreation = false
          notificationService.notify({type: "info", message: event?.msg?.text, dismiss: 3000})
          folderService.fetchAllFolders()
          propertyService.fetchByFolderId(event?.msg?.folderid, true)
          break;

        case eventType.SAMPLE_PROPERTIES_ERROR:
          this.sampleCreation = false
          notificationService.notify({type: "danger", message: event?.msg?.text, dismiss: 3000})
          break;

        case eventType.UNDERWRITING_WORKBOOK_COMPLETED:
          current = event?.msg?.type === "folder" ? folderService.get(event?.msg?.folderid) : propertyService.get(event?.msg?.propertyid)
          notificationService.enqueue({
            message: `${event?.msg?.message}: ${_.get(current, "code")}`,
            correlationid: event?.msg?.type === "folder" ? `underwriting-folder-${event?.msg?.folderid}` : `underwriting-property-${event?.msg?.propertyid}`,
            complete: true
          })
          break;

        case eventType.UNDERWRITING_WORKBOOK_ERROR:
          current = event?.msg?.type === "folder" ? folderService.get(event?.msg?.folderid) : propertyService.get(event?.msg?.propertyid)
          notificationService.notify({type: "danger", message: `Underwriting Workbook for ${_.capitalize(event?.msg?.type)}: ${current.code} failed. Please create a support ticket.`, sticky: true, dismiss: 3000})
          notificationService.enqueue({
            message: `Underwriting workbook failed for ${_.get(current, "code")}`,
            correlationid: event?.msg?.type === "folder" ? `underwriting-folder-${event?.msg?.folderid}` : `underwriting-property-${event?.msg?.propertyid}`,
            complete: true
          })
          break;

        // case eventType.FOLDER_CALC_STARTED_EVENT:
        //   socketService.newEvent({ eventType: eventType.FOLDER_CALC_STARTED_EVENT, event })
        //   notificationService.notify({ type: "info", message: event.msg, dismiss: 5000 })
        //   break;

        // case eventType.FOLDER_CALC_ERROR_EVENT:
        //   socketService.newEvent({ eventType: eventType.FOLDER_CALC_ERROR_EVENT, event })
        //   notificationService.notify({ type: "danger", message: event.msg, dismiss: 5000 })
        //   break;

        // case eventType.FOLDER_CALC_FINISHED_EVENT:
        //   socketService.newEvent({ eventType: eventType.FOLDER_CALC_FINISHED_EVENT, event })
        //   notificationService.notify({ type: "info", message: event.msg, dismiss: 5000 })
        //   let folderId = localStorage.getItem('folderPath') ? _.last(JSON.parse(localStorage.getItem('folderPath')!)) : -1
        //   setTimeout(() => propertyService.fetchByFolderId(folderId), 1000)
        //   break;

        // case eventType.PROPERTY_CALC_IN_PROGRESS:
        //   propertyService.fetchProperty(+event.msg)
        //     .then(property => {
        //       socketService.newEvent({ eventType: eventType.USERCHANNEL_CALC_PROPERTY_SYNC, event: {property} })
        //     })
        //   break;

        // case eventType.PROPERTY_CALC_FINISHED:
        //   setTimeout(() => propertyService.fetchProperty(+event.msg), 1000)
        //   break;

        default:
          console.warn('UserChannel got unknown eventType on:', event)
      }
    });
  }
}